// 营销活动模块多语言配置
export const marketing = {
  'zh-CN': {
    // 秒杀活动
    flashSaleProductList: '秒杀商品列表',
    drafts: '草稿箱',
    flashSale: '秒杀',
    flashSaleProduct: '秒杀商品',
    
    // 秒杀添加页面
    addFlashSaleProduct: '添加秒杀商品',
    limitedTimeFlashSale: '限时秒杀',
    promotionalFlashSale: '促销秒杀',
    flashSaleAmount: '秒杀金额',
    flashSaleAmountCannotBeLessThanZero: '秒杀金额不能小于0！',
    flashSaleAmountAndStockCannotBeEmpty: '秒杀金额和库存不能为空或者零！',
    flashSaleAmountCannotExceedProductPrice: '秒杀金额不能大于商品价格！',
    flashSaleQuantityCannotExceedTotalStock: '秒杀数量不能大于商品总库存！',
    pleaseSelectActivityType: '请选择活动类型',
    
    // 优惠券管理
    addCoupon: '添加优惠券',
    couponName: '优惠券名称',
    usageScope: '使用范围',
    distributionMethod: '发放方式',
    distributionTarget: '发放对象',
    receiveQuantity: '领取数量（张）',
    couponType: '优惠券类型',
    couponDiscount: '优惠券折扣/金额',
    minimumSpend: '最低消费金额',
    issueRemaining: '发券/剩余',
    distributionDate: '发放日期',
    validDate: '有效日期',
    publishStatus: '发布状态',
    discount: '折扣',
    amount: '金额',
    unlimited: '不限量',
    pieces: '张',
    
    // 分销管理
    totalCommissionPaid: '累计发放佣金',
    withdrawnAmount: '已提现金额',
    pendingDeliveryOrders: '待收货订单',
    pendingAmount: '待到账金额',
    commissionExpenseStatistics: '佣金支出统计',
    distributionProductRatio: '分销商品占比',
    startDate: '开始日期',
    endDate: '结束日期',
    search: '搜索',
    commission: '佣金',
    sales: '销售额',
    
    // 拼团活动
    groupBuy: '拼团',
    groupBuyProduct: '拼团商品',
    groupBuyList: '拼团列表',
    participants: '参与者',
    groupBuyOrders: '拼团订单',
    
    // 拼团添加页面
    activityDuration: '活动时长',
    maxCreateGroupsPerAccount: '单账号最多开团数',
    groupSize: '成团人数',
    pleaseEnterPeopleCount: '请输入人数',
    groupSizeGreaterThanOne: '拼团人数 > 1',
    maxPurchasePerAccount: '单账号最多购买数',
    groupValidityHours: '拼团有效期(小时)',
    maxJoinGroupsPerAccount: '单账号最多参团数',
    pleaseEnterHours: '请输入人数',
    pleaseSelectActivityDuration: '请选择活动时长',
    pleaseEnterGroupSize: '请输入成团人数',
    pleaseEnterGroupValidity: '请输入拼团有效期',
    noteFillStock: '注：请填写商品库存，一旦拼团人数和购买数量达到商品库存的值，该拼团则进入关闭状态，用户点击拼团或参团则提示"该商品已售罄"。',
    addGroupProduct: '添加拼团商品',
    addProduct: '+添加商品',
    productId: '产品ID',
    product: '产品',
    category: '分类',
    price: '价格',
    stock: '库存',
    totalSales: '总销量',
    publishTime: '发布时间',
    selectProductSpec: '选择商品规格',
    productName: '商品名称',
    productType: '商品类型',
    productSpec: '商品规格',
    productStock: '商品库存',
    operation: '操作',
    groupAmount: '拼团金额',
    activityStock: '活动库存',
    yuan: '港元',
    selectProduct: '选择商品',
    cancel: '取消',
    confirm: '确定',
    saveToDrafts: '保存到草稿箱',
    publish: '发布',
    saveEdit: '保存编辑',
    pleaseSelectProductFirst: '请先选择商品',
    groupAmountCannotBeLessThanZero: '商品拼团金额不能小于0！',
    groupAmountAndStockCannotBeEmpty: '商品规格拼团金额和拼团库存不能为空或者零！',
    groupAmountCannotExceedProductPrice: '商品拼团金额不能大于商品价格！',
    groupQuantityCannotExceedTotalStock: '商品拼团数量不能大于商品总库存！',
    publishSuccess: '发布成功',
    saveSuccess: '保存成功',
    publishFailed: '发布失败',
    saveFailed: '保存失败',
    
    // 通用营销活动
    activityList: '活动列表',
    createActivity: '创建活动',
    editActivity: '编辑活动',
    activityStatus: '活动状态',
    activityType: '活动类型',
    active: '进行中',
    inactive: '已结束',
    draft: '草稿',
    discountActivity: '折扣活动',
    couponActivity: '优惠券活动',
    flashSaleActivity: '限时抢购',
    activityName: '活动名称',
    activityDescription: '活动描述',
    startTime: '开始时间',
    endTime: '结束时间',
    targetAudience: '目标受众',
    startActivity: '启动活动',
    stopActivity: '停止活动',
    viewStatistics: '查看统计',
    exportData: '导出数据',
    
    // 优惠券添加页面
    couponName: '优惠券名称',
    minimumSpend: '优惠劵最低消费',
    yuan: '港元',
    couponType: '优惠券类型',
    pleaseSelect: '请选择',
    fullReductionCoupon: '满减券',
    discountCoupon: '折扣券',
    couponFaceValue: '优惠券面值',
    pleaseEnterCouponFaceValue: '请输入优惠券面值',
    fullAmountReduction: '满{amount}港元减',
    discount: '折扣',
    pleaseEnterDiscount: '请输入折扣',
    fold: '折',
    useScope: '使用范围',
    universal: '全场通用',
    byCategory: '按品类使用',
    selectProductCategory: '选择商品分类',
    special: '专用',
    distributionDate: '发劵日期',
    startDate: '开始日期',
    endDate: '结束日期',
    effectiveDate: '使用有效日期',
    distributionMethod: '发放方式',
    newUserGift: '新用户赠劵',
    homepageGift: '首页赠劵',
    distributionQuantity: '发放数量',
    pleaseEnterDistributionQuantity: '请输入发放数量',
    maxPerUser: '同一用户最多发放',
    pleaseEnter: '请输入',
    distributionStatus: '发放状态',
    enable: '启用',
    disable: '禁用',
    remarks: '备注',
    remarksContent: '备注内容',
    pleaseSelectProductCategory: '请选择商品分类',
    couponAmountCannotExceedMinimum: '优惠券金额不得大于最低消费金额',
    pleaseEnterCouponName: '请输入优惠券名称',
    pleaseEnterMinimumSpend: '请输入优惠劵最低消费金额',
    pleaseSelectCouponType: '请选择优惠券类型',
    pleaseEnterCouponFaceValue: '请输入优惠券面值',
    pleaseSelectDistributionDate: '请选择发劵日期',
    pleaseSelectEffectiveDate: '请选择使用有效日期',
    pleaseSelectDistributionMethod: '请选择发放方式',
    pleaseEnterDistributionQuantity: '请输入发放数量',
    pleaseEnterMaxDistribution: '请输入最多发放数量',
    pleaseSelectDistributionStatus: '请选择发放状态',
    pleaseEnterDiscount: '请输入折扣',
    
    // 优惠券详情页面
    couponStatus: '优惠券状态',
    search: '搜索',
    serialNumber: '序号',
    receivingUser: '领取用户',
    couponName: '优惠券名称',
    distributionMethod: '发放方式',
    couponDiscountAmount: '优惠券折扣/金额',
    minimumSpendAmount: '最低消费金额',
    distributionDate: '发放日期',
    effectiveDate: '有效日期',
    receivingTime: '领取时间',
    status: '状态',
    all: '全部',
    pendingUse: '待使用',
    used: '已使用',
    expired: '已过期',
    to: '到',
    
    // 拼团活动
    groupBuy: '拼团',
    groupBuyActivity: '拼团活动',
    groupBuyProduct: '拼团商品',
    groupBuyList: '拼团列表',
    groupBuyDetail: '拼团详情',
    groupBuyStatus: '拼团状态',
    groupBuySuccess: '拼团成功',
    groupBuyFailed: '拼团失败',
    groupBuyRefunded: '已退款',
    groupBuyInProgress: '拼团中',
    groupBuyLeader: '开团团长',
    groupBuyMember: '参团成员',
    groupBuyMinMembers: '成团人数',
    groupBuyMaxPurchase: '单账号最多可购买数',
    groupBuyMaxOpenGroups: '单账号最多可开团数',
    groupBuyMaxJoinGroups: '单账号最多可参团数',
    groupBuyRemainingMembers: '还差人数',
    groupBuyStartTime: '开始时间',
    groupBuyEndTime: '结束时间',
    groupBuyTime: '拼团时间',
    groupBuyFailedPendingRefund: '拼团失败（待退款）',
    groupBuyFailedRefunded: '拼团失败（已退款）',
    groupBuyProductList: '拼团商品列表',
    
    // 订单信息
    orderDetail: '订单详情',
    orderInfo: '订单信息',
    productInfo: '商品信息',
    orderNumber: '订单编号',
    userNickname: '用户昵称',
    paymentAmount: '付款金额',
    orderTime: '下单时间',
    orderStatus: '订单状态',
    pendingPayment: '待付款',
    pendingShipment: '待发货',
    pendingReceipt: '待收货',
    completed: '已完成',
    cancelled: '交易取消',
    refundSuccess: '退款成功',
    groupBuyInfo: '团购信息',
    participantInfo: '参团信息',
    productName: '商品名称',
    
    // 通用操作
    status: '状态',
    search: '搜索',
    operation: '操作',
    detail: '详情',
    start: '起',
    end: '止',
    all: '全部',


  },
  'zh-TW': {
    // 秒杀活动
    flashSaleProductList: '秒殺商品列表',
    drafts: '草稿箱',
    flashSale: '秒殺',
    flashSaleProduct: '秒殺商品',
    
    // 秒杀添加页面
    addFlashSaleProduct: '添加秒殺商品',
    limitedTimeFlashSale: '限時秒殺',
    promotionalFlashSale: '促銷秒殺',
    flashSaleAmount: '秒殺金額',
    flashSaleAmountCannotBeLessThanZero: '秒殺金額不能小於0！',
    flashSaleAmountAndStockCannotBeEmpty: '秒殺金額和庫存不能為空或者零！',
    flashSaleAmountCannotExceedProductPrice: '秒殺金額不能大於商品價格！',
    flashSaleQuantityCannotExceedTotalStock: '秒殺數量不能大於商品總庫存！',
    pleaseSelectActivityType: '請選擇活動類型',
    
    // 优惠券管理
    addCoupon: '添加優惠券',
    couponName: '優惠券名稱',
    usageScope: '使用範圍',
    distributionMethod: '發放方式',
    distributionTarget: '發放對象',
    receiveQuantity: '領取數量（張）',
    couponType: '優惠券類型',
    couponDiscount: '優惠券折扣/金額',
    minimumSpend: '最低消費金額',
    issueRemaining: '發券/剩餘',
    distributionDate: '發放日期',
    validDate: '有效日期',
    publishStatus: '發布狀態',
    discount: '折扣',
    amount: '金額',
    unlimited: '不限量',
    pieces: '張',
    
    // 分銷管理
    totalCommissionPaid: '累計發放佣金',
    withdrawnAmount: '已提現金額',
    pendingDeliveryOrders: '待收貨訂單',
    pendingAmount: '待到賬金額',
    commissionExpenseStatistics: '佣金支出統計',
    distributionProductRatio: '分銷商品佔比',
    startDate: '開始日期',
    endDate: '結束日期',
    search: '搜索',
    commission: '佣金',
    sales: '銷售額',
    
    // 拼團活動
    groupBuy: '拼團',
    groupBuyProduct: '拼團商品',
    groupBuyList: '拼團列表',
    participants: '參與者',
    groupBuyOrders: '拼團訂單',
    
    // 拼團添加頁面
    activityDuration: '活動時長',
    maxCreateGroupsPerAccount: '單賬號最多開團數',
    groupSize: '成團人數',
    pleaseEnterPeopleCount: '請輸入人數',
    groupSizeGreaterThanOne: '拼團人數 > 1',
    maxPurchasePerAccount: '單賬號最多購買數',
    groupValidityHours: '拼團有效期(小時)',
    maxJoinGroupsPerAccount: '單賬號最多參團數',
    pleaseEnterHours: '請輸入人數',
    pleaseSelectActivityDuration: '請選擇活動時長',
    pleaseEnterGroupSize: '請輸入成團人數',
    pleaseEnterGroupValidity: '請輸入拼團有效期',
    noteFillStock: '注：請填寫商品庫存，一旦拼團人數和購買數量達到商品庫存的值，該拼團則進入關閉狀態，用戶點擊拼團或參團則提示"該商品已售罄"。',
    addGroupProduct: '添加拼團商品',
    addProduct: '+添加商品',
    productId: '產品ID',
    product: '產品',
    category: '分類',
    price: '價格',
    stock: '庫存',
    totalSales: '總銷量',
    publishTime: '發布時間',
    selectProductSpec: '選擇商品規格',
    productName: '商品名稱',
    productType: '商品類型',
    productSpec: '商品規格',
    productStock: '商品庫存',
    operation: '操作',
    groupAmount: '拼團金額',
    activityStock: '活動庫存',
    yuan: '港元',
    selectProduct: '選擇商品',
    cancel: '取消',
    confirm: '確定',
    saveToDrafts: '保存到草稿箱',
    publish: '發布',
    saveEdit: '保存編輯',
    pleaseSelectProductFirst: '請先選擇商品',
    groupAmountCannotBeLessThanZero: '商品拼團金額不能小於0！',
    groupAmountAndStockCannotBeEmpty: '商品規格拼團金額和拼團庫存不能為空或者零！',
    groupAmountCannotExceedProductPrice: '商品拼團金額不能大於商品價格！',
    groupQuantityCannotExceedTotalStock: '商品拼團數量不能大於商品總庫存！',
    publishSuccess: '發布成功',
    saveSuccess: '保存成功',
    publishFailed: '發布失敗',
    saveFailed: '保存失敗',
    
    // 通用營銷活動
    activityList: '活動列表',
    createActivity: '創建活動',
    editActivity: '編輯活動',
    activityStatus: '活動狀態',
    activityType: '活動類型',
    active: '進行中',
    inactive: '已結束',
    draft: '草稿',
    discountActivity: '折扣活動',
    couponActivity: '優惠券活動',
    flashSaleActivity: '限時搶購',
    activityName: '活動名稱',
    activityDescription: '活動描述',
    startTime: '開始時間',
    endTime: '結束時間',
    targetAudience: '目標受眾',
    startActivity: '啟動活動',
    stopActivity: '停止活動',
    viewStatistics: '查看統計',
    exportData: '導出數據',
    
    // 优惠券添加页面
    couponName: '優惠券名稱',
    minimumSpend: '優惠劵最低消費',
    yuan: '港元',
    couponType: '優惠券類型',
    pleaseSelect: '請選擇',
    fullReductionCoupon: '滿減券',
    discountCoupon: '折扣券',
    couponFaceValue: '優惠券面值',
    pleaseEnterCouponFaceValue: '請輸入優惠券面值',
    fullAmountReduction: '滿{amount}港元減',
    discount: '折扣',
    pleaseEnterDiscount: '請輸入折扣',
    fold: '折',
    useScope: '使用範圍',
    universal: '全場通用',
    byCategory: '按品類使用',
    selectProductCategory: '選擇商品分類',
    special: '專用',
    distributionDate: '發劵日期',
    startDate: '開始日期',
    endDate: '結束日期',
    effectiveDate: '使用有效日期',
    distributionMethod: '發放方式',
    newUserGift: '新用戶贈劵',
    homepageGift: '首頁贈劵',
    distributionQuantity: '發放數量',
    pleaseEnterDistributionQuantity: '請輸入發放數量',
    maxPerUser: '同一用戶最多發放',
    pleaseEnter: '請輸入',
    distributionStatus: '發放狀態',
    enable: '啟用',
    disable: '禁用',
    remarks: '備註',
    remarksContent: '備註內容',
    pleaseSelectProductCategory: '請選擇商品分類',
    couponAmountCannotExceedMinimum: '優惠券金額不得大於最低消費金額',
    pleaseEnterCouponName: '請輸入優惠券名稱',
    pleaseEnterMinimumSpend: '請輸入優惠劵最低消費金額',
    pleaseSelectCouponType: '請選擇優惠券類型',
    pleaseEnterCouponFaceValue: '請輸入優惠券面值',
    pleaseSelectDistributionDate: '請選擇發劵日期',
    pleaseSelectEffectiveDate: '請選擇使用有效日期',
    pleaseSelectDistributionMethod: '請選擇發放方式',
    pleaseEnterDistributionQuantity: '請輸入發放數量',
    pleaseEnterMaxDistribution: '請輸入最多發放數量',
    pleaseSelectDistributionStatus: '請選擇發放狀態',
    pleaseEnterDiscount: '請輸入折扣',
    
    // 优惠券详情页面
    couponStatus: '優惠券狀態',
    search: '搜索',
    serialNumber: '序號',
    receivingUser: '領取用戶',
    couponName: '優惠券名稱',
    distributionMethod: '發放方式',
    couponDiscountAmount: '優惠券折扣/金額',
    minimumSpendAmount: '最低消費金額',
    distributionDate: '發放日期',
    effectiveDate: '有效日期',
    receivingTime: '領取時間',
    status: '狀態',
    all: '全部',
    pendingUse: '待使用',
    used: '已使用',
    expired: '已過期',
    to: '到',
    
    // 拼团活动
    groupBuy: '拼團',
    groupBuyActivity: '拼團活動',
    groupBuyProduct: '拼團商品',
    groupBuyList: '拼團列表',
    groupBuyDetail: '拼團詳情',
    groupBuyStatus: '拼團狀態',
    groupBuySuccess: '拼團成功',
    groupBuyFailed: '拼團失敗',
    groupBuyRefunded: '已退款',
    groupBuyInProgress: '拼團中',
    groupBuyLeader: '開團團長',
    groupBuyMember: '參團成員',
    groupBuyMinMembers: '成團人數',
    groupBuyMaxPurchase: '單賬號最多可購買數',
    groupBuyMaxOpenGroups: '單賬號最多可開團數',
    groupBuyMaxJoinGroups: '單賬號最多可參團數',
    groupBuyRemainingMembers: '還差人數',
    groupBuyStartTime: '開始時間',
    groupBuyEndTime: '結束時間',
    groupBuyTime: '拼團時間',
    groupBuyFailedPendingRefund: '拼團失敗（待退款）',
    groupBuyFailedRefunded: '拼團失敗（已退款）',
    groupBuyProductList: '拼團商品列表',
    
    // 订单信息
    orderDetail: '訂單詳情',
    orderInfo: '訂單信息',
    productInfo: '商品信息',
    orderNumber: '訂單編號',
    userNickname: '用戶暱稱',
    paymentAmount: '付款金額',
    orderTime: '下單時間',
    orderStatus: '訂單狀態',
    pendingPayment: '待付款',
    pendingShipment: '待發貨',
    pendingReceipt: '待收貨',
    completed: '已完成',
    cancelled: '交易取消',
    refundSuccess: '退款成功',
    groupBuyInfo: '團購信息',
    participantInfo: '參團信息',
    productName: '商品名稱',
    
    // 通用操作
    status: '狀態',
    search: '搜索',
    operation: '操作',
    detail: '詳情',
    start: '起',
    end: '止',
    all: '全部',
  },
  'en': {
    // 秒杀活动
    flashSaleProductList: 'Flash Sale Product List',
    drafts: 'Drafts',
    flashSale: 'Flash Sale',
    flashSaleProduct: 'Flash Sale Product',
    
    // 秒杀添加页面
    addFlashSaleProduct: 'Add Flash Sale Product',
    limitedTimeFlashSale: 'Limited Time Flash Sale',
    promotionalFlashSale: 'Promotional Flash Sale',
    flashSaleAmount: 'Flash Sale Amount',
    flashSaleAmountCannotBeLessThanZero: 'Flash sale amount cannot be less than 0!',
    flashSaleAmountAndStockCannotBeEmpty: 'Flash sale amount and stock cannot be empty or zero!',
    flashSaleAmountCannotExceedProductPrice: 'Flash sale amount cannot exceed product price!',
    flashSaleQuantityCannotExceedTotalStock: 'Flash sale quantity cannot exceed total product stock!',
    pleaseSelectActivityType: 'Please select activity type',
    
    // 优惠券管理
    addCoupon: 'Add Coupon',
    couponName: 'Coupon Name',
    usageScope: 'Usage Scope',
    distributionMethod: 'Distribution Method',
    distributionTarget: 'Distribution Target',
    receiveQuantity: 'Receive Quantity (Pieces)',
    couponType: 'Coupon Type',
    couponDiscount: 'Coupon Discount/Amount',
    minimumSpend: 'Minimum Spend',
    issueRemaining: 'Issue/Remaining',
    distributionDate: 'Distribution Date',
    validDate: 'Valid Date',
    publishStatus: 'Publish Status',
    discount: 'Discount',
    amount: 'Amount',
    unlimited: 'Unlimited',
    pieces: 'Pieces',
    
    // 分销管理
    totalCommissionPaid: 'Total Commission Paid',
    withdrawnAmount: 'Withdrawn Amount',
    pendingDeliveryOrders: 'Pending Delivery Orders',
    pendingAmount: 'Pending Amount',
    commissionExpenseStatistics: 'Commission Expense Statistics',
    distributionProductRatio: 'Distribution Product Ratio',
    startDate: 'Start Date',
    endDate: 'End Date',
    search: 'Search',
    commission: 'Commission',
    sales: 'Sales',
    
    // 拼团活动
    groupBuy: 'Group Buy',
    groupBuyProduct: 'Group Buy Product',
    groupBuyList: 'Group Buy List',
    participants: 'Participants',
    groupBuyOrders: 'Group Buy Orders',
    
    // 拼团添加页面
    activityDuration: 'Activity Duration',
    maxCreateGroupsPerAccount: 'Max Create Groups Per Account',
    groupSize: 'Group Size',
    pleaseEnterPeopleCount: 'Please enter people count',
    groupSizeGreaterThanOne: 'Group size > 1',
    maxPurchasePerAccount: 'Max Purchase Per Account',
    groupValidityHours: 'Group Validity (Hours)',
    maxJoinGroupsPerAccount: 'Max Join Groups Per Account',
    pleaseEnterHours: 'Please enter hours',
    pleaseSelectActivityDuration: 'Please select activity duration',
    pleaseEnterGroupSize: 'Please enter group size',
    pleaseEnterGroupValidity: 'Please enter group validity',
    noteFillStock: 'Note: Please fill in product stock. Once the group size and purchase quantity reach the product stock value, the group will enter the closed state, and users will be prompted "This product is sold out" when clicking group buy or join group.',
    addGroupProduct: 'Add Group Product',
    addProduct: '+Add Product',
    productId: 'Product ID',
    product: 'Product',
    category: 'Category',
    price: 'Price',
    stock: 'Stock',
    totalSales: 'Total Sales',
    publishTime: 'Publish Time',
    selectProductSpec: 'Select Product Specification',
    productName: 'Product Name',
    productType: 'Product Type',
    productSpec: 'Product Specification',
    productStock: 'Product Stock',
    operation: 'Operation',
    groupAmount: 'Group Amount',
    activityStock: 'Activity Stock',
    yuan: 'HK$',
    selectProduct: 'Select Product',
    cancel: 'Cancel',
    confirm: 'Confirm',
    saveToDrafts: 'Save to Drafts',
    publish: 'Publish',
    saveEdit: 'Save Edit',
    pleaseSelectProductFirst: 'Please select product first',
    groupAmountCannotBeLessThanZero: 'Product group amount cannot be less than 0!',
    groupAmountAndStockCannotBeEmpty: 'Product specification group amount and group stock cannot be empty or zero!',
    groupAmountCannotExceedProductPrice: 'Product group amount cannot exceed product price!',
    groupQuantityCannotExceedTotalStock: 'Product group quantity cannot exceed total product stock!',
    publishSuccess: 'Publish Success',
    saveSuccess: 'Save Success',
    publishFailed: 'Publish Failed',
    saveFailed: 'Save Failed',
    
    // 通用营销活动
    activityList: 'Activity List',
    createActivity: 'Create Activity',
    editActivity: 'Edit Activity',
    activityStatus: 'Activity Status',
    activityType: 'Activity Type',
    active: 'Active',
    inactive: 'Inactive',
    draft: 'Draft',
    discountActivity: 'Discount Activity',
    couponActivity: 'Coupon Activity',
    flashSaleActivity: 'Flash Sale Activity',
    activityName: 'Activity Name',
    activityDescription: 'Activity Description',
    startTime: 'Start Time',
    endTime: 'End Time',
    targetAudience: 'Target Audience',
    startActivity: 'Start Activity',
    stopActivity: 'Stop Activity',
    viewStatistics: 'View Statistics',
    exportData: 'Export Data',
    
    // 优惠券添加页面
    couponName: 'Coupon Name',
    minimumSpend: 'Minimum Spend',
    yuan: 'HK$',
    couponType: 'Coupon Type',
    pleaseSelect: 'Please Select',
    fullReductionCoupon: 'Full Reduction Coupon',
    discountCoupon: 'Discount Coupon',
    couponFaceValue: 'Coupon Face Value',
    pleaseEnterCouponFaceValue: 'Please Enter Coupon Face Value',
    fullAmountReduction: 'Full {amount} Yuan Reduction',
    discount: 'Discount',
    pleaseEnterDiscount: 'Please Enter Discount',
    fold: 'Fold',
    useScope: 'Usage Scope',
    universal: 'Universal',
    byCategory: 'By Category',
    selectProductCategory: 'Select Product Category',
    special: 'Special',
    distributionDate: 'Distribution Date',
    startDate: 'Start Date',
    endDate: 'End Date',
    effectiveDate: 'Effective Date',
    distributionMethod: 'Distribution Method',
    newUserGift: 'New User Gift',
    homepageGift: 'Homepage Gift',
    distributionQuantity: 'Distribution Quantity',
    pleaseEnterDistributionQuantity: 'Please Enter Distribution Quantity',
    maxPerUser: 'Max Per User',
    pleaseEnter: 'Please Enter',
    distributionStatus: 'Distribution Status',
    enable: 'Enable',
    disable: 'Disable',
    remarks: 'Remarks',
    remarksContent: 'Remarks Content',
    pleaseSelectProductCategory: 'Please Select Product Category',
    couponAmountCannotExceedMinimum: 'Coupon amount cannot exceed minimum spend',
    pleaseEnterCouponName: 'Please Enter Coupon Name',
    pleaseEnterMinimumSpend: 'Please Enter Minimum Spend',
    pleaseSelectCouponType: 'Please Select Coupon Type',
    pleaseEnterCouponFaceValue: 'Please Enter Coupon Face Value',
    pleaseSelectDistributionDate: 'Please Select Distribution Date',
    pleaseSelectEffectiveDate: 'Please Select Effective Date',
    pleaseSelectDistributionMethod: 'Please Select Distribution Method',
    pleaseEnterDistributionQuantity: 'Please Enter Distribution Quantity',
    pleaseEnterMaxDistribution: 'Please Enter Max Distribution',
    pleaseSelectDistributionStatus: 'Please Select Distribution Status',
    pleaseEnterDiscount: 'Please Enter Discount',
    
    // 优惠券详情页面
    couponStatus: 'Coupon Status',
    search: 'Search',
    serialNumber: 'Serial Number',
    receivingUser: 'Receiving User',
    couponName: 'Coupon Name',
    distributionMethod: 'Distribution Method',
    couponDiscountAmount: 'Coupon Discount/Amount',
    minimumSpendAmount: 'Minimum Spend Amount',
    distributionDate: 'Distribution Date',
    effectiveDate: 'Effective Date',
    receivingTime: 'Receiving Time',
    status: 'Status',
    all: 'All',
    pendingUse: 'Pending Use',
    used: 'Used',
    expired: 'Expired',
    to: 'to',
    
    // 拼团活动
    groupBuy: 'Group Buy',
    groupBuyActivity: 'Group Buy Activity',
    groupBuyProduct: 'Group Buy Product',
    groupBuyList: 'Group Buy List',
    groupBuyDetail: 'Group Buy Detail',
    groupBuyStatus: 'Group Buy Status',
    groupBuySuccess: 'Group Buy Success',
    groupBuyFailed: 'Group Buy Failed',
    groupBuyRefunded: 'Refunded',
    groupBuyInProgress: 'In Progress',
    groupBuyLeader: 'Group Leader',
    groupBuyMember: 'Group Member',
    groupBuyMinMembers: 'Min Members',
    groupBuyMaxPurchase: 'Max Purchase Per Account',
    groupBuyMaxOpenGroups: 'Max Open Groups Per Account',
    groupBuyMaxJoinGroups: 'Max Join Groups Per Account',
    groupBuyRemainingMembers: 'Remaining Members',
    groupBuyStartTime: 'Start Time',
    groupBuyEndTime: 'End Time',
    groupBuyTime: 'Group Buy Time',
    groupBuyFailedPendingRefund: 'Group Buy Failed (Pending Refund)',
    groupBuyFailedRefunded: 'Group Buy Failed (Refunded)',
    groupBuyProductList: 'Group Buy Product List',
    
    // 订单信息
    orderDetail: 'Order Detail',
    orderInfo: 'Order Information',
    productInfo: 'Product Information',
    orderNumber: 'Order Number',
    userNickname: 'User Nickname',
    paymentAmount: 'Payment Amount',
    orderTime: 'Order Time',
    orderStatus: 'Order Status',
    pendingPayment: 'Pending Payment',
    pendingShipment: 'Pending Shipment',
    pendingReceipt: 'Pending Receipt',
    completed: 'Completed',
    cancelled: 'Cancelled',
    refundSuccess: 'Refund Success',
    groupBuyInfo: 'Group Buy Information',
    participantInfo: 'Participant Information',
    productName: 'Product Name',
    
    // 通用操作
    status: 'Status',
    search: 'Search',
    operation: 'Operation',
    detail: 'Details',
    start: 'Start',
    end: 'End',
    all: 'All',
  }
}; 